import { takeData } from '../../../shared/misc/api-utils';
import { setCoreSettings } from '../model/core-settings';

export const fetchCore = async () => {
  const url = new URL(window.location.origin);
  url.pathname = 'coreSettings.json';

  return fetch(url).then(takeData).then(setCoreSettings);
};
